import { Instance } from 'mobx-state-tree'
import { RecursiveRemoveUndefined } from '../../utils'
import { ChatMessageModelBase } from './ChatMessageModel.base'

/* The TypeScript type of an instance of ChatMessageModel */
export interface ChatMessageModelType extends RecursiveRemoveUndefined<Instance<typeof ChatMessageModel>> {}

/* A graphql query fragment builders for ChatMessageModel */
export { selectFromChatMessage, chatMessageModelPrimitives, ChatMessageModelSelector } from './ChatMessageModel.base'

/**
 * ChatMessageModel
 */
export const ChatMessageModel = ChatMessageModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
